// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form[data-v-03bb6a62]{flex-basis:50%}.loader[data-v-03bb6a62]{width:25px;height:25px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
